import { CurrencySettings } from "./CurrencySettings";
import { SubscriptionSettings } from "./SubscriptionSettings";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const PreferencesSettings = () => {
  return (
    <div className="space-y-6">
      <SubscriptionSettings />
      <Card>
        <CardHeader>
          <CardTitle>Préférences</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <CurrencySettings />
        </CardContent>
      </Card>
    </div>
  );
};